import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NaturalLanguageEditorComponent } from './natural-language-editor.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NaturalLanguageEditorKeyphraseAbstractDirective } from './natural-language-editor-keyphrase/natural-language-editor-keyphrase.abstract.directive';
import { NaturalLanguageEditorSingleComponent } from './natural-language-editor-keyphrase/natural-language-editor-single/natural-language-editor-single.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NaturalLanguageEditorDoubleComponent } from './natural-language-editor-keyphrase/natural-language-editor-double/natural-language-editor-double.component';
import { NaturalLanguageEditorDatepickerComponent } from './natural-language-editor-keyphrase/natural-language-editor-datepicker/natural-language-editor-datepicker.component';
import { PipesModule } from '../pipes/pipes.module';
import { DatePickerModule } from 'primeng/datepicker';
import { TooltipModule } from 'primeng/tooltip';
import { Popover } from 'primeng/popover';

@NgModule({
  declarations: [
    NaturalLanguageEditorComponent,
    NaturalLanguageEditorKeyphraseAbstractDirective,
    NaturalLanguageEditorSingleComponent,
    NaturalLanguageEditorDoubleComponent,
    NaturalLanguageEditorDatepickerComponent,
  ],
  exports: [
    NaturalLanguageEditorComponent,
    NaturalLanguageEditorSingleComponent,
    NaturalLanguageEditorDoubleComponent,
    NaturalLanguageEditorDatepickerComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    NgbModule,
    NgSelectModule,
    FormsModule,
    PipesModule,
    DatePickerModule,
    TooltipModule,
    Popover,
  ],
})
export class NaturalLanguageEditorModule {}
